@let currentElementResponse = currentElement$();
@if(currentElementResponse.success) {
  @let currentElement = currentElementResponse.payload;
  @let tag = currentElement.tag;
  @let value = currentElement.value;
  @let styleId = currentElement.styles;

  <div 
    appClickOutside 
    [ngClass]="customClass()" 
    class="editable-container"
    [isActive]="showEditButton && isEditMode$()" 
    (clickOutside)="onClickOutside()">
    @if(showEditButton && isEditMode$()) {
      <button 
        class="edit-button" 
        (click)="openConfig($event)">
        Text bearbeiten
      </button>
    }
    @if(metaConfigOpen) {
      <app-meta-config 
        [elemId]="elemId()"
        [styleId]="styleId" 
        [CSDElementRef]="textElementRef()"
        [eType]="eType"
        (closePanel)="closeMetaConfig()">
      </app-meta-config>
    }
    
    <div (click)="onEdit()" [ngClass]="{'editable-field': isEditMode$()}" class="field-label">
      @if(tag == 'h1') {<h1 #textElement [ngStyle]="styles$()" class="custom-display-large" [attr.contenteditable]="isEditMode$()" (input)="onInput($event)" (blur)="onBlur($event)">{{ value}}</h1>}
      @else if(tag == 'h2') {<h2 #textElement [ngStyle]="styles$()" class="custom-headline-medium" [attr.contenteditable]="isEditMode$()" (input)="onInput($event)" (blur)="onBlur($event)">{{ value}}</h2>}
      @else if(tag == 'h3') {<h3 #textElement [ngStyle]="styles$()" class="custom-title-medium" [attr.contenteditable]="isEditMode$()" (input)="onInput($event)" (blur)="onBlur($event)">{{ value}}</h3>}
      @else if(tag == 'h4') {<h4 #textElement [ngStyle]="styles$()" class="custom-title-large" [attr.contenteditable]="isEditMode$()" (input)="onInput($event)" (blur)="onBlur($event)">{{value}}</h4>}
      @else if(tag == 'p') {<p #textElement [ngStyle]="styles$()" class="custom-body-medium" [attr.contenteditable]="isEditMode$()" (input)="onInput($event)" (blur)="onBlur($event)">{{ value}}</p>}
      @else if(tag == 'p-large') {<p #textElement [ngStyle]="styles$()" class="custom-body-large" [attr.contenteditable]="isEditMode$()" (input)="onInput($event)" (blur)="onBlur($event)">{{ value}}</p>}
      @else if(tag == 'span') {<span #textElement [ngStyle]="styles$()" [attr.contenteditable]="isEditMode$()" (input)="onInput($event)" (blur)="onBlur($event)">{{ value}}</span>}
    </div>
  </div>
}